"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateProperty = void 0;

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _upgradeDataStates = require("ui-addon-upgrades/_core/common/data/upgradeData/upgradeDataStates");

var validateProperty = function validateProperty(isValid, message, propName) {
  if (!isValid) {
    _devLogger.default.warn({
      message: "createUpgradeData: " + message,
      key: "createUpgradeData: " + propName
    });

    return _upgradeDataStates.UPGRADE_DATA_INVALID;
  }

  return _upgradeDataStates.UPGRADE_DATA_VALID;
};

exports.validateProperty = validateProperty;